import { render, staticRenderFns } from "./ShowMoreModal.vue?vue&type=template&id=0bcc37b0&"
import script from "./ShowMoreModal.vue?vue&type=script&lang=js&"
export * from "./ShowMoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports